<template>
  <div
    class="root"
    
  >
    <img
      class="single-logo"
      src="./imgs/motul-logo.svg"
    >
    <div class="container">
      <img
        class="right-icon"
        src="./imgs/r.png"
      >

      <div class="z-c"> {{ $t("newPage.text1") }}</div>
      <div class="f-c">{{ $t("newPage.text2") }}</div>
      <div class="line"></div>

      <div class="n-1"> {{ $t("newPage.text3") }} {{computedModelCode}}</div>
      <div class="n-2"> {{ $t("newPage.text4") }} {{serialNub}}</div>
      <div class="btn-root">
        <div
          class="btn"
          @click="page1Link"
        > {{ $t("newPage.btn") }}</div>
      </div>
    

    </div>
  </div>
</template>

<script>
export default {
  computed: {
    computedModelCode() { //型号
      const key = this.modelCode;
      return this.$t(key);
    },
    computedDetail() { // 产品详情
      const key = "page2." + this.modelCode;
      return this.$t(key);
    },
  },
  data() {
    return {
      modelCode: "", //产品型号
      serialNub: "1089466", //固定编码序列号
      modelCodeImg: "", //产品图片
      screenHeight:"",//屏幕高度,
      VALUES :{//缓存的值
        model5012X1L: [1091361,1091049,1088775,1091359,1068850],
        model5W40: [1077737,1067227,1084714,1089805,1073658],
        model4012X1L: [1089806,1073898,1092169,1091917,1091918],
        model20X1L: [1060232,1084186,1073665,1060258,1089465],
    },
    };
  },
  mounted() {
    this.screenHeight = window.innerHeight+'px'
    function getURLParameter(name) { //获取参数值
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name);
    }
    const modelCode = getURLParameter("m"); //获取型号
    // const serialNub = getURLParameter("s"); //获取编码
    this.modelCode = modelCode;
    // this.serialNub = serialNub;
   
    document.title = this.$t('HTMLtitle');//设置语言动态title
    // this.serialNub = this.getRandomValueWithCache(modelCode);
    // 使用
      // console.log(this.getRandomValueWithCache(modelCode));
  },
  methods: {
    page1Link() {//不同的语言，链接也不一样，还查一个链接
      window.location.href = this.$t(`${this.modelCode}Go`)
    },
    page2Link() {
      window.location.href = "https://www.motul.com/sg/en/products";
    },
    nextPage() {
      this.swiperInstance.slideNext(); // 切换到下一页
    },
    //设置缓存
    setLocalCache(key, value, ttl) {
      let item = {
        value: value,
        expiry: Date.now() + ttl
      };
      localStorage.setItem(key, JSON.stringify(item));
    },
      //获取缓存
      getLocalCache(key) {
          const itemStr = localStorage.getItem(key);
            // 缓存不存在
            if (!itemStr) return null;
             const item = JSON.parse(itemStr);
            // 检查是否过期
            if (Date.now() > item.expiry) {
              localStorage.removeItem(key); // 清除过期缓存
              return null;
            }
            return item.value;
        },
        getRandomValueWithCache(code) {//随机值
            // 尝试从缓存获取
            const cached = this.getLocalCache(code);
            if (cached !== null) {
              return cached;
            }
            // 缓存失效，生成新值
            let val = this.VALUES[this.modelCode]
            const randomValue = val[Math.floor(Math.random() * val.length)];
            // console.log('tag1', this.VALUES[this.modelCode])
            // console.log('tag2', randomValue)
            // 存入缓存，有效期24小时
            this.setLocalCache(code, randomValue, 24 * 60 * 60 * 1000);
            return randomValue;
      }
  },



  beforeDestroy() {
    this.swiperInstance.destroy();
  },
};
</script>
 
<style scoped>
.a{
  height: 20px;
  width: 100px;
}
.root {
  width: 100%;
  text-align: center;
}
.single-logo {
  width: 2.3rem;
  height: auto;
  margin: 0.25rem 0;
  padding-top: 0.2rem;
}
.container {
  margin: 0 7%;
  /* width: 92%; */
  height: 10.3rem;
  background: #fff;
  position: relative;
}
.right-icon {
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;
  margin-top: 0.7rem;
}
.z-c {
  font-size: 0.45rem;
  font-weight: 900;
  margin-bottom: 0.3rem;
}
.f-c {
  font-size: 0.28rem;
  width: 100%;
  margin-left: 0.3rem;
  text-align: left;
  /* color: #484c4e; */
  font-family: math;
}
.line {
  margin: 0.5rem 0.3rem 0.6rem 0.3rem;
  position: relative;
  height: 1px;
  background-color: #fff;
  box-shadow: 0 1px #48464666 inset;
}
.n-1 {
  font-size: 0.28rem;
  text-align: left;
  margin-left: 0.3rem;
  /* color: #484c4e; */
  margin-bottom: 0.1rem;
  font-family: math;
}
.n-2 {
  font-size: 0.28rem;
  text-align: left;
  margin-left: 0.3rem;
  /* color: #484c4e; */
  font-family: math;
}
.btn-root {
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
}
.btn {
  /* font-size: 0.26rem;
  width: 4.1rem;
  height: 0.7rem;
  line-height: 0.7rem;
  border-radius: 0.07rem;
  color: #fff;
  background: red;
  text-align: center;
  position: absolute;
  bottom: 1.5rem;
  font-weight: 600; */
    font-size: 0.3rem;
    width: 4.3rem; 
    height: 0.75rem;
    line-height: 0.75rem;
    border-radius: 0.07rem;
    color: #fff;
    background: red;
    text-align: center;
    position: absolute;
    bottom: 1.5rem;
    font-weight: 600;
}
</style>
